import '../sass/single-product.scss';
import './calculator';
import './type';
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

    let three;
    let four;

    function initSwiper() {
        if (window.innerWidth < 630) {
            if (!three) {
                three = new Swiper('.three__flex', {
                    modules: [Navigation, Pagination],
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: '.three__nav-right',
                        prevEl: '.three__nav-left',
                    },
                });
            }
        } else if (three) {
            three.destroy(true, true);
            three = null;
        }


        if (window.innerWidth < 630) {
            if (!four) {
                four = new Swiper('.four__flex', {
                    modules: [Navigation, Pagination],
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: '.four__nav-right',
                        prevEl: '.four__nav-left',
                    },
                });
            }
        } else if (four) {
            four.destroy(true, true);
            four = null;
        }

    }

    window.addEventListener('resize', initSwiper);
    initSwiper();

});